import { nanoid } from 'nanoid';
import { FilterOperator, type FilterProperties } from '~/components2/Table/AdvancedFilterV2';

export const getAssignedToMe = (name?: string): FilterProperties[] => {
  return [
    {
      id: nanoid(),
      type: 'rule',
      columnId: 'assignedToName',
      value: name ?? '',
      operator: FilterOperator.Includes,
    },
  ];
};

export const NOT_INTERNAL_ORG: FilterProperties = {
  id: nanoid(),
  type: 'rule',
  columnId: 'organization.isInternal',
  value: 'false',
  operator: FilterOperator.IsFalse,
};
